import { Component, OnInit, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormGroup, FormControl } from '@angular/forms';
import { AutoUnsubscribe } from '../../../decorators/auto-unsubscribe';
import { AdministrativeCenter } from '../../../interfaces/administrativeCenter';
import { SharedPanelService } from '../../../../dms/layout/shared-panel/shared-panel.service';
import { GestionTercerosService } from '../../../../dms/modulos/general/componentes/gestion-terceros/gestion-terceros.service';
import { environment } from '../../../../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { GeneralGestionTercerosService } from '../../../../dms/modulos/general/componentes/gestion-terceros/servicios/general-gestion-tercerosService.Service';

@Component({
    selector: 'app-administrative-centers',
    templateUrl: './administrative-centers.component.html',
    styleUrls: ['./administrative-centers.component.scss']
})

@AutoUnsubscribe()
export class AdministrativeCentersComponent implements OnInit {
    customerId: string;
    subjectCustomer: Subscription;
    public formCenters: FormGroup;
    administrativeCenters1: AdministrativeCenter[] = [];
    administrativeCenters2: AdministrativeCenter[] = [];
    administrativeCenters3: AdministrativeCenter[] = [];
    administrativeCenters4: AdministrativeCenter[] = [];
    @Input() formMode: boolean;
    @Input() modoEdicion: boolean;
    selectedCenter: AdministrativeCenter;
    selectedDefault: any;
    primerCampo: AdministrativeCenter;
    deshabilitarCampos: boolean;
    code: string;
    dataCustomer: any;
    constructor(
        public _generalGestionTercerosService: GeneralGestionTercerosService,
        private toastr: ToastrService,
        public _sharedPanelService: SharedPanelService,
        public _gestionTercerosService: GestionTercerosService,
    ) {
        this.primerCampo = {
            Address: '',
            CodeCenter: '',
            Description: 'Seleccionar',
            FirstName: '',
            IsoCode: '',
            LastName: '',
            LogicalOperationalPoint: '',
            Name: '',
            PhysicalGLN: '',
            PostalCode: '',
            Province: '',
            RoleTypeCode: '',
            Town: '',
            ID: 0
        };
    }
    ngOnInit() {
        if (this.formMode || !this.modoEdicion) {
            this.deshabilitarCampos = true;
        } else {
            this.deshabilitarCampos = false;
        }
        this.dataCustomer = this._gestionTercerosService.getByCustomerCodeWithContactsSave();
        this.formCenters = new FormGroup({
            AdminCenterEReceptorId: new FormControl(),
            AdminCenterEPayerId: new FormControl(),
            AdminCenterEFiscalId: new FormControl(),
            AdminCenterEBuyerId: new FormControl()
        });
        this.cargarCombos();


    }

    cargarCombos() {
        const _URL_ = `${environment.ENTORNO}Services/Invoicing/AdministrativeCenterService.svc/Find`;
        const Parametros_IN = {
            searchValue: '',
            OrderBy: null
        };
        this._generalGestionTercerosService.getAdministrativeCenterService(_URL_, Parametros_IN).subscribe((data) => {
            const auxdata = data.Response;
            if (auxdata && auxdata.length > 0) {
                this.administrativeCenters1 = auxdata.filter(
                    item => { if (item.RoleTypeCode === "01") return item }
                );

                this.administrativeCenters2 = auxdata.filter(
                    item => { if (item.RoleTypeCode === "02") return item }
                );

                this.administrativeCenters3 = auxdata.filter(
                    item => { if (item.RoleTypeCode === "03") return item }
                );

                this.administrativeCenters4 = auxdata.filter(
                    item => { if (item.RoleTypeCode === "04") return item }
                );
            }
            this.prepararDefault();
        });
    }

    prepararDefault() {
        this.administrativeCenters1.unshift(this.primerCampo);
        this.administrativeCenters2.unshift(this.primerCampo);
        this.administrativeCenters3.unshift(this.primerCampo);
        this.administrativeCenters4.unshift(this.primerCampo);
        if( this.dataCustomer){
            this.formCenters.get('AdminCenterEReceptorId').setValue(
                this.dataCustomer.AdminCenterEReceptorId ? this.dataCustomer.AdminCenterEReceptorId : this.administrativeCenters1[0].ID);
            this.formCenters.get('AdminCenterEPayerId').setValue(
                this.dataCustomer.AdminCenterEPayerId ? this.dataCustomer.AdminCenterEPayerId : this.administrativeCenters2[0].ID);
            this.formCenters.get('AdminCenterEFiscalId').setValue(
                this.dataCustomer.AdminCenterEFiscalId ? this.dataCustomer.AdminCenterEFiscalId : this.administrativeCenters3[0].ID);
            this.formCenters.get('AdminCenterEBuyerId').setValue(
                this.dataCustomer.AdminCenterEBuyerId ? this.dataCustomer.AdminCenterEBuyerId : this.administrativeCenters4[0].ID);
        }
        // if (this.deshabilitarCampos) {
        //     this.formCenters.get('AdminCenterEReceptorId').disable();
        //     this.formCenters.get('AdminCenterEPayerId').disable();
        //     this.formCenters.get('AdminCenterEFiscalId').disable();
        //     this.formCenters.get('AdminCenterEBuyerId').disable();
        // } else {
        this.formCenters.get('AdminCenterEReceptorId').enable();
        this.formCenters.get('AdminCenterEPayerId').enable();
        this.formCenters.get('AdminCenterEFiscalId').enable();
        this.formCenters.get('AdminCenterEBuyerId').enable();
        // }
    }

    public valueChange(value: any): void {

        this._gestionTercerosService.customerForm.controls.centres = this.formCenters;

    }

    borrar(data) {
        switch (data) {
            case 'AdminCenterEReceptorId':
                this.formCenters.get(data).setValue(this.administrativeCenters1[0].ID);
                break;
            case 'AdminCenterEPayerId':
                this.formCenters.get(data).setValue(this.administrativeCenters2[0].ID);
                break;
            case 'AdminCenterEFiscalId':
                this.formCenters.get(data).setValue(this.administrativeCenters3[0].ID);
                break;
            case 'AdminCenterEBuyerId':
                this.formCenters.get(data).setValue(this.administrativeCenters4[0].ID);
                break;
        }
    }
}

